const postAreasStr = {
  toastrSuccess: 'Added department',
  toastrSuccess1: ' has been successfully added',
  toastrError: 'Department already registered', 
  toastrError2: 'Enter another name'
};

export default postAreasStr;
